<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex xs12 sm8 md4 lg3>
        <h2 class="dark--text font-weight-bold">Plan Transfer List</h2>
      </v-flex>

      <v-flex xs12 sm8 md4 lg3>
        <v-text-field solo dense name="input-7-4" label="Search Phone" type="number" @keydown.enter="runSearch()" v-model="filter.searchKey"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 sm8 md4 lg3>
        <ExportTransfer class="mt-n3" :planTransferHistory="planTransferHistory" :headers="headers" />
      </v-flex>
    </v-layout>

    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="planTransferHistory"
      class="elevation-1"
      :items-per-page="25"
      :options.sync="options"
      :loading="loading"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template v-slot:item.fromCustomer="{ item }"> {{ item.from.user.firstnameEn }} {{ item.from.user.lastnameEn }} </template>
      <template v-slot:item.fromPhone="{ item }">
        {{ item.from.user.phone }}
      </template>
      <template v-slot:item.fromOrder="{ item }">
        {{ item.from.subscription.order_number }}
      </template>

      <template v-slot:item.toCustomer="{ item }"> {{ item.to.user.firstnameEn }} {{ item.to.user.lastnameEn }} </template>
      <template v-slot:item.toPhone="{ item }">
        {{ item.to.user.phone }}
      </template>
      <template v-slot:item.toOrder="{ item }">
        {{ item.to.subscription.order_number }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ExportTransfer from "../components/ExportTransfer.vue";
export default {
  components: { ExportTransfer },

  mounted() {
    this.$root.$on("getAllPlanTransferHistories", () => {
      this.loading = true;
      this.getAllPlanTransferHistories();
    });
  },
  data: () => ({
    loading: true,
    totalItems: 25,
    planTransferHistory: [],
    options: {
      itemsPerPage: 25,
      page: 1,
    },
    filter: {
      status: "ALL",
      searchKey: "",
    },
    headers: [
      {
        text: "From Customer",
        value: "fromCustomer",
        sortable: false,
        width: 150,
      },
      {
        text: "From Phone",
        value: "fromPhone",
        sortable: false,
        width: 120,
      },

      {
        text: "To Order",
        value: "toOrder",
        sortable: false,
        width: 120,
      },

      {
        text: "To Customer",
        value: "toCustomer",
        sortable: false,
        width: 150,
      },
      {
        text: "To Phone",
        value: "toPhone",
        sortable: false,
        width: 120,
      },
      {
        text: "To Order",
        value: "toOrder",
        sortable: false,
        width: 120,
      },
    ],
  }),

  methods: {
    runSearch() {
      this.getAllPlanTransferHistories();
    },
    getAllPlanTransferHistories() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getAllPlanTransferHistories.graphql"),
          variables: {
            limit: 25,
            skip: 0,
            searchKey: this.filter.searchKey,
          },
        })
        .refetch({
          limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
          skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
          searchKey: this.filter.searchKey,
        })
        .then(data => {
          this.loading = false;
          if (data.data.getAllPlanTransferHistories) {
            this.planTransferHistory = data.data.getAllPlanTransferHistories.planTransferHistory;
            this.totalItems = data.data.getAllPlanTransferHistories.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.getAllPlanTransferHistories();
      },
      deep: true,
    },
  },
  created() {
    this.getAllPlanTransferHistories();
    if (!this.hasRole(this.AdminUserPermissions.PLAN_TRANSFER_LIST)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },
};
</script>
